import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import { message } from 'antd';
import {
  getMeetingRoomUseList,
  initiatorName,
  addSignWall,
  modifySignWall,
  getSignWall,
  getMinutes,
  addMeeting,
  getMeetingInfo,
  meetingCancel,
} from '../../../../services/meetingManage/create';

const initState = {
  activeKey: '1',
  meetingRoomList: [],
  initiatorNameData: {},
  signWallDetailModal: false,
  signWallDetailData: { logeName: '', qrCode: '' },
  minustesListData: [],
  selectedMinustesListData: [],
  tempSelectedMinustesListData: [],
  publishModalVisible: false, // 发布确认弹框
  meetingId: 0,
  formData: {
    meetingTitle: '',
    meetingParticipantUsersModuleId: '',
    meetingStartTimeString: moment().add(10, 'm'),
    meetingEndTimeString: moment().add(70, 'm'),
    meetingContent: '',
    fileId: '',
    fileCount: 0,
    meetingRoomId: '',
    remark: '',
    isNeedRemark: null,
    isNeedSign: 0,
    participantNum: '',
    meetingSamePermissionsModuleId: '', // 相同权限人
    remindType: 1, // 消息提醒
    isTiming: 0, // 是否定时发送
    publishTimeString: moment().add(2, 'hours'), // 定时发送时间
    initiatorNameType: 1,
    initiatorName: '',
    meetingSignwallId: 0,
    meetingMinuteserUsers: [],
    source: 'pc',
  },
  spinProps: {
    spinning: false,
    tip: '加载中...',
  },
};

export default {
  namespace: 'createMeeting',

  state: initState,

  effects: {
    *fetchMeetingRoomUseList({ params }, { call, put }) {
      try {
        const response = yield call(getMeetingRoomUseList, params);

        yield put({
          type: 'save',
          payload: {
            meetingRoomList: response,
            meetingRoomId: '',
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },
    *fetchInitiatorName({ params }, { call, put, select }) {
      try {
        const response = yield call(initiatorName, params);
        const { formData } = yield select(state => state.createMeeting);

        yield put({
          type: 'save',
          payload: {
            initiatorNameData: response,
            formData: { ...formData, initiatorName: response.deptName },
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },
    *fetchAddSignWall({ params }, { call, put }) {
      try {
        const response = yield call(addSignWall, params);
        yield put({
          type: 'saveState',
          payload: {
            signWallDetailData: response,
          },
        });
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(String(e));
      }
    },
    *fetchModifySignWall({ params }, { call, put }) {
      try {
        const response = yield call(modifySignWall, params);
        yield put({
          type: 'saveState',
          payload: {
            signWallDetailData: response,
          },
        });
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(String(e));
      }
    },
    *fetchSignWall({ params }, { call, put }) {
      try {
        const response = yield call(getSignWall, params);
        yield put({
          type: 'saveState',
          payload: {
            signWallDetailData: response,
          },
        });
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(String(e));
      }
    },
    *fetchMinutes({ params }, { call }) {
      try {
        const response = yield call(getMinutes, params);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(String(e));
      }
    },
    *fetchAddMeeting({ params }, { call, put, select }) {
      try {
        if (!params.saveType) {
          yield put({
            type: 'save',
            payload: {
              spinProps: {
                spinning: true,
              },
            },
          });
        }
        const { meetingId } = yield select(state => state.createMeeting);
        const response = yield call(addMeeting, { ...params, id: params.id || meetingId || 0 });
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
            meetingId: response.id,
          },
        });
        if (params.saveType === 'autoSave' && !sessionStorage.getItem('autoSave')) {
          message.info('内容已自动保存至发件箱');
          sessionStorage.setItem('autoSave', 'alreadySave');
        }
        if (!params.saveType) {
          if (params.status === 1) {
            message.success('发布成功');
          }
          router.goBack();
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },
    *fetchMeetingInfo({ params }, { call, put, select }) {
      try {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: true,
            },
          },
        });
        const { formData } = yield select(state => state.createMeeting);

        const response = yield call(getMeetingInfo, params);
        const formDataTemp = {
          ...formData,
          ...response,
          meetingStartTimeString: moment(response.meetingStartTime),
          meetingEndTimeString: moment(response.meetingEndTime),
          publishTimeString:
            response.isTiming === 1 ? moment(response.publishTimeString) : moment().add(2, 'hours'),
        };
        const selectedMinustesListData = [];
        const tempSelectedMinustesListData = [];
        const { meetingMinuteserUsers } = response;
        meetingMinuteserUsers.forEach(item => {
          selectedMinustesListData.push(item.meetingUserUserid);
          tempSelectedMinustesListData.push(item.meetingUserUserid);
        });
        yield put({
          type: 'save',
          payload: {
            formData: formDataTemp,
            spinProps: {
              spinning: false,
            },
            selectedMinustesListData,
            tempSelectedMinustesListData,
          },
        });
        return Promise.resolve(formDataTemp);
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
        return Promise.reject(String(error));
      }
    },
    *fetchMeetingCancel({ params }, { call, put }) {
      try {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        yield call(meetingCancel, params);
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
        router.goBack();
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState };
    },
  },
};
